module.exports = __webpack_public_path__ + "static/SilkSerif-Light-e958371b93dc17b86494a5b767874bab.woff";